import Mute from '@/javascripts/components/Mute';

const mute = new Mute({ isCardLayout: true });

document.addEventListener('DOMContentLoaded', () => {
  mute.setMuteActions({ dataType: 'User' });
  mute.addToggleMuteEvent();
  initializeToggleMuteComponentMutationObserver();
});

function initializeToggleMuteComponentMutationObserver() {
  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      Array.from(mutation.addedNodes)
        .filter((node): node is Element => node.nodeType === Node.ELEMENT_NODE)
        .forEach(() => {
          mute.setMuteActions({ dataType: 'User' });
        });
    });
  });
  const observeTarget = document.body;
  mutationObserver.observe(observeTarget, { childList: true });
}
